var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"zSkfBdvXkJsZuHoOE2dbj"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/lk";

import { BrowserOptions } from '@sentry/browser/types/client';
import * as Sentry from '@sentry/nextjs';

const SENTRY_OPTIONS = process.env.NEXT_PUBLIC_SENTRY_OPTIONS;

const sentryOptions: BrowserOptions = SENTRY_OPTIONS
  ? JSON.parse(SENTRY_OPTIONS)
  : {
      dsn: 'https://d59c9f939dd9414596e4df8c4fe39bf7@sentry.smart-gates.net/3',
      environment: 'local',
      tracesSampleRate: 1.0,
    };

sentryOptions.tracesSampler = (samplingContext: any) => {
  // Пока не отправляем информацию о загрузке страницы
  if (samplingContext.transactionContext.op === 'pageload') {
    return 0;
  }

  return 1;
};

Sentry.init(sentryOptions);
